import * as React from "react"
import {Box} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";


export default function sponsoredColumn() {
	return [{
		name: 'sponsored', label: 'Sponsored',
		options: {
			display: 'excluded',
			customBodyRowRender: value => value ? 'Yes' : 'No'
		}
	},{
		name: 'sponsored', label: 'Sponsored',
		options: {
			filter: false,
			customBodyRowRender: value => <Box sx={{ textAlign: 'center', fontSize: 21 }}>
				{ !!value && <IconSeeker icon="check" sx={{ color: "success.main" }} /> }
				{ !value && <IconSeeker icon="xmark" sx={{ color: "error.main" }} /> }
			</Box>
		}
	}]
}